module.exports = __webpack_public_path__ + "img/qrcode_for_gh_84617f4b5028_258.f6c6d79a.jpg";